<template>
  <modal class="q-modal warning-window-modal popup_dialog" name="warning-window-modal" :class="ifTop"
       transition="nice-modal-fade"
       :width="400"
       :min-width="400"
       height="auto"
       :delay="100"
       :draggable="'.modal-header'"
       :clickToClose="false"
       :adaptive="true"
       classes='q-v--modal'>
    <div class="modal-content">
      <div class="modal-header">
        <span class="dialog-icon icon-warning"></span>
        {{$t('warningWin.title')}}
      </div>
      <div class="icon-btn_close modal-close" @click="onClose(true)"></div>
      <div class="modal-body">
        <div class="modal-container">
          {{$t('warningWin.content')}}
        </div>
      </div>
      <div class="modal-footer">
        <div class="footer-left">
        </div>
        <div class="footer-right">
          <button class="q-button blue-btn-full" @click="onOk()" :title="$t('yes')">{{$t('yes')}}</button>
          <button class="q-button" @click="onClose()" :title="$t('cancel')">{{$t('cancel')}}</button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: 'warning-win',
  props: {
    onChange: Function
  },
  data () {
    return {
      modalname: 'warning-window-modal',
      showModal: true
    }
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal'
    ]),
    onOk: function () {
      this.closeModal(this.modalname)
      this.$modal.hide(this.modalname)
      this.onChange()
    },
    onOpen () {
      this.openModal(this.modalname)
      this.$modal.show(this.modalname)
    },
    onClose (cancel) {
      this.closeModal(this.modalname)
      this.$modal.hide(this.modalname)
    }
  },
  computed: {
    ...mapGetters(['getTopModalName']),
    ifTop () {
      this.$log.debug('this.getTopModalName :' + this.getTopModalName)

      if (this.getTopModalName !== this.modalname) {
        return 'noTopModal'
      } else {
        return 'none'
      }
    }
  }
}
</script>

<style lang="scss" scoped>

@import '../assets/scss/modal.scss';

.warning-window-modal {
  .q-v--modal {
    .modal-content {
      .modal-header {
        > .dialog-icon {
          font-size: 30px;
          vertical-align: middle;
          &.icon-warning {
            color: #F5A623;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/WarningWin.vue